import { Injectable } from "@angular/core";
import { GameType, ItemType } from "@apiserver-rest/ponder-data-client-base";
import { PreviewItemFilters } from "./preview-item-filters";
import { DefaultItemFilter } from "./default-item-filter";
import { EventBroker } from "@ponder-core/events/eventBroker";
import { MagicCardFilters } from "@ponder-features/magic/card/filter/magic-card-filters";

/**
 * Constructs {@link PreviewItemFilters} for a specified game.
 */
@Injectable({ providedIn: "root" })
export class PreviewItemFilterFactory {
    private sharedFilters = new Map<[GameType, ItemType], PreviewItemFilters>();

    public constructor(private events: EventBroker) {

    }

    public build(game: GameType, item: ItemType): PreviewItemFilters {
        var filter = this.sharedFilters.get([game, item]);

        if (!filter) {
            switch (game) {
                case GameType.Magic:
                    filter = (item == ItemType.Card) ? new MagicCardFilters(this.events) : new DefaultItemFilter(this.events);
                    break;
                
                default:
                    filter = new DefaultItemFilter(this.events);
                    break;
            }
        }
        
        return filter;
    }
}